import React from "react";
import EvacuadosPorProvinciaTmp from '../../../containers/EvacuadosPorProvincia';
import { CAMPAIGN_2026 } from '../../../constants';

const EvacuadosPorProvincia = () => {

  return <EvacuadosPorProvinciaTmp campaign={CAMPAIGN_2026} year={2026}/>;
};

export default EvacuadosPorProvincia;
